<section>
  <div class="header">
    <h1>{{ 'Makulera bostadsrättskontrakt' | translate }}</h1>
  </div>
  <div class="form-group">{{ 'LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER' | translate }}: {{ leaseAgreementNumber }}</div>

  <div class="row">
    <p class="col-12 help-text">{{ 'VOID_LEASE_AGREEMENT_FORM.HELP_TEXT.FUNCTION_DESCRIPTION_COOPERATIVE_HOUSING' | translate }}</p>
  </div>

  <div class="form-group">
    <div class="row">
      <div class="col-12">
        <app-text-area [control]="form.controls['voidDescription']" [helpText]="'VOID_LEASE_AGREEMENT_FORM.HELP_TEXT.NOTE'"></app-text-area>
      </div>
    </div>
  </div>

  <div class="form-group">
    @if (displayCreditInvoices) {
      <div class="row">
        <div class="col-12">
          <h6 class="mb-2">
            <span class="d-inline-block">
              <span class="mr-4">{{ 'VOID_LEASE_AGREEMENT_FORM.CREDIT_INVOICES' | translate }}</span>
            </span>
          </h6>
          <app-multiselect-list-view
            [itemsSource]="invoices"
            [columnDefinition]="invoicesColumnDefinitions"
            [selectAll]="true"
            [preferencesKey]="'rent.void-coop-lease-agreement.invoices'"
            >
          </app-multiselect-list-view>
        </div>
      </div>
    }
  </div>
</section>

<section>
  <div>
    <button class="btn btn-outlined" [disabled]="invoices === undefined" (click)="save()">
      {{ 'SAVE_BTN' | translate }}
    </button>
    <button class="btn btn-outlined ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
  </div>
</section>
